import {BaseValidatedClass} from '../BaseValidatedClass';

export class UIElementTagRegistry extends BaseValidatedClass {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS = ['registerUiElements'];

  constructor() {
    super(UIElementTagRegistry.REQUIRED_METHODS, UIElementTagRegistry);
  }

  public registerUiElements(_uiElementsTagsMap: Record<string, string>): void {
    throw new Error('Method registerUiElements() must be implemented by the subclass');
  }
}
